module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": _vm.title,
      "size": "full",
      "destroyed-on-close": "true"
    },
    model: {
      value: (_vm.show),
      callback: function($$v) {
        _vm.show = $$v
      },
      expression: "show"
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "element-loading-text": _vm.isEditData === 0 ? '修改保存中。。。' : '新增保存中。。。'
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form', {
    ref: "pInfo1",
    attrs: {
      "model": _vm.pInfo1,
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    staticClass: "h20",
    attrs: {
      "label": "guid"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "guid,修改时用"
    },
    model: {
      value: (_vm.pInfo1.guid),
      callback: function($$v) {
        _vm.pInfo1.guid = $$v
      },
      expression: "pInfo1.guid"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_vm._v("\n         \n      ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 15
    }
  }, [_c('el-row', [_c('span', [_vm._v("题目内容")])])], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8aeee700"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/problemUserSubmitDlg/src/main.vue
// module id = 650
// module chunks = 3